import React, { PropsWithChildren, useState } from 'react';
import { Icons, SVG } from '../../../components/atoms/SVG';
import { ExtendedInfoStateIndicator, ExtendedInfoSVG } from '../../../_lib/components/ExtendedInfo';
import { TooltipPlacement } from '../../../components/atoms/Tooltip';
import { Siblings } from './Siblings';
import { useSonTranslation } from '../../../translation/useSonTranslation';
import { StateIndicator } from '../../../_lib/components/StateIndicator';
import { BreadcrumbNavItem } from '../../../types/api/NavItem';
import { BreadcrumbFlyoutProps } from './BreadcrumbFlyout';

type BreadCrumbItemContainerProps = {
  hasReadRestrictions: boolean;
  siblings?: BreadcrumbFlyoutProps;
  navItem: BreadcrumbNavItem;
  index: number;
};

export function BreadCrumbItemContainer({
  hasReadRestrictions,
  siblings,
  navItem,
  index,
  children,
}: PropsWithChildren<BreadCrumbItemContainerProps>) {
  const { t } = useSonTranslation('Breadcrumb');
  const [stateIndicatorStatus] = useState<StateIndicator['status'] | null>(() => {
    if (navItem.packState === 'onlyDraftVersion') {
      return 'red';
    }

    if (navItem.packState === 'template') {
      return 'purple';
    }

    return null;
  });

  return (
    <>
      <span className="breadcrumb__iconcontainer">
        <SVG svgSpriteId={Icons.BREADCRUMB_SLASH} />
      </span>
      {stateIndicatorStatus ? (
        <span className="breadcrumb__extended-info">
          <ExtendedInfoStateIndicator
            tooltipPlacement={TooltipPlacement.TOP}
            stateIndicatorStatus={stateIndicatorStatus}
          />
        </span>
      ) : null}
      {children}
      {hasReadRestrictions ? (
        <span className="breadcrumb__extended-info-svg">
          <ExtendedInfoSVG
            helpText={t('readRestrictionDescriptionText')}
            tooltipPlacement={TooltipPlacement.TOP}
            svgSpriteID={Icons.CLOSED_LOCK}
          />
        </span>
      ) : null}
      {siblings && siblings.groups.length > 0 ? <Siblings navItem={navItem} siblings={siblings} index={index} /> : null}
    </>
  );
}
